import { Grid } from "@mui/material";
import TitleCustom from "components/CustomTitle";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import Footer from "layouts/Footer";
import getSalesData from "models/getSalesData";
import { useCallback, useEffect, useState } from "react";
import { getQuarters, getSalesSummaryByYear } from "rest/requests";
import getLineChartData from "../resumen_ventas/data/lineChartData";
import { formatTableData } from "./formatTableData";
import { getExcelData } from "./getExcelData";
//import { user } from "rest/salesByQuartersRequests";

//components
// @mui material components

// Data

function SalesPerQuarter() {
  const [showChart, setShowChart] = useState(false);
  // ------ Year select ----------
  const [year, setYear] = useState(new Date().getFullYear());
  const current_year = new Date().getFullYear();
  const handleYear = (event) => {
    const {
      target: { value },
    } = event;
    if (value <= current_year) {
      setYear(value);
    }
  };
  // ------ Year select END----------

  // Getting needed data
  // const userData = user();
  // console.log(userData);

  const [salesSummaryYearData, setSalesSummaryYearData] = useState([]);

  const getData = useCallback(async () => {
    console.log("getData.useCallback");
    const dataTemp = await getSalesSummaryByYear(year);

    const quarters = await getQuarters(year);
    const quarterCompleteData = quarters.length > 0 ? quarters : [182, 64, 46, 47];

    const _salesSummaryYearData = getSalesData(dataTemp, quarterCompleteData);
    setSalesSummaryYearData(_salesSummaryYearData);
  }, [year]);

  useEffect(() => {
    getData();
  }, [year]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div id="divToExport">
        <TitleCustom
          title={"Resumen de Ventas por Trimestre"}
          excelData={getExcelData(salesSummaryYearData)}
          excelName={"Reporte_Ventas_Por_Trimestre_" + year + ".xlsx"}
          showChart={showChart}
          setShowChart={setShowChart}
        ></TitleCustom>

        <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
          <Grid container>
            <Grid item>
              <MDInput type="number" label="Year" value={year} onChange={handleYear} />
            </Grid>
          </Grid>
        </MDBox>
        <br></br>
        {showChart ? (
          <MDBox mb={6}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg>
                <DefaultLineChart
                  icon={{ color: "info", component: "leaderboard" }}
                  title="Resumen anual de ventas"
                  description="Representación por Trimestres"
                  chart={getLineChartData(salesSummaryYearData)}
                  height="30rem"
                />
              </Grid>
            </Grid>
          </MDBox>
        ) : (
          <DataTable table={formatTableData(salesSummaryYearData)} canSearch={true} />
        )}
      </div>
      <Footer />
    </DashboardLayout>
  );
}

export default SalesPerQuarter;
